import React from "react";
import Row from "../Flex/Row";
function defaultSubmit(e) {
    e.preventDefault();
}
export default function Form(props) {
    const { onSubmit, children } = props;
    return (React.createElement("form", { onSubmit: onSubmit || defaultSubmit },
        React.createElement(Row, { ...props }, children)));
}
